import {
  ExperimentsAction,
  ExperimentAnalyticsLoadingState,
  ExperimentAnalyticsErrorState,
  ExperimentAnalyticsOverviewTabState,
} from 'modules/experiments/types';
import { initialAnalyticsOverviewTabData } from 'modules/experiments/constants';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';

export const initialAnalyticsOverviewTabState: ExperimentAnalyticsOverviewTabState = {
  data: initialAnalyticsOverviewTabData,
  [ExperimentAnalyticsLoadingState.OVERVIEW_TAB]: false,
  [ExperimentAnalyticsErrorState.OVERVIEW_TAB]: false,
};

export const experimentAnalyticsOverviewTabReducer = (
  state = initialAnalyticsOverviewTabState,
  action?: ExperimentsAction,
) => {
  switch (action?.type) {
    case ActionTypes.ANALYTICS_PAGE_OVERVIEW_TAB_LOADED:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.OVERVIEW_TAB]: true,
      };

    case ActionTypes.SET_ANALYTICS_OVERVIEW_TAB_DATA: {
      const overviewTabData = action?.payload;
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.OVERVIEW_TAB]: false,
        [ExperimentAnalyticsErrorState.OVERVIEW_TAB]: false,
        data: overviewTabData || state.data,
      };
    }

    case ActionTypes.ANALYTICS_RELOAD_OVERVIEW_TAB_DATA:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.OVERVIEW_TAB]: true,
        [ExperimentAnalyticsErrorState.OVERVIEW_TAB]: false,
      };

    case ActionTypes.ANALYTICS_OVERVIEW_TAB_DATA_LOADED:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.OVERVIEW_TAB]: false,
      };

    case ActionTypes.ANALYTICS_OVERVIEW_TAB_DATA_ERROR:
      return {
        ...state,
        [ExperimentAnalyticsLoadingState.OVERVIEW_TAB]: false,
        [ExperimentAnalyticsErrorState.OVERVIEW_TAB]: true,
      };

    default:
      return state;
  }
};
